import React, { useState } from "react";
import styles from "./StatusUpdate.module.css";
import OnlyDropDown from "../../components/OnlyDropDown/OnlyDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice"; // Update the path as per your setup

const StatusUpdate = () => {
  const dispatch = useDispatch();
  const statusOptions = ["Active", "Inactive", "Pending", "Blocked"];
  const [selectedStatus, setSelectedStatus] = useState("");

  const handleUpdate = () => {
    if (!selectedStatus) {
      alert("Please select a status");
      return;
    }
    console.log("Status updated to:", selectedStatus);
    // dispatch(updateStatusAction(selectedStatus)); // Optional: your update API
    dispatch(closeModal());
  };

  const handleCancel = () => {
    console.log("Status update canceled");
    dispatch(closeModal());
  };

  return (
    <div className={styles.modalContainer}>
      <div className={styles.modalHeader}>Select Status</div>
      <div className={styles.modalBody}>
        <OnlyDropDown
          label="Choose Status"
          name="status"
          value={selectedStatus}
          options={statusOptions}
          onChange={(e) => setSelectedStatus(e.target.value)}
        />
      </div>
      <div className={styles.modalFooter}>
        <SaveAndCancel
          onCancel={handleCancel}
          onSave={handleUpdate}
          cancelLabel="Cancel"
          saveLabel="Update"
        />
      </div>
    </div>
  );
};

export default StatusUpdate;
